<mat-form-field [appearance]="appearance" class="mb-n3">
    <mat-label>{{ label }}</mat-label>
    <mat-select
        [formControl]="selectCtrl"
        [sbTestSelector]="sbTestSelector"
        [disabled]="disabled"
        omitInnerText="true"
        [compareWith]="compareFn"
        #matSelect
    >
        <main>
            <mat-option
                *ngFor="let option of options; let i = index"
                [value]="valueKey ? option[valueKey] : option"
                [sbTestSelector]="sbTestSelector"
                [sbTestIndex]="i"
                [style.font-size]="appearance === 'none' ? '14px' : null"
                omitInnerText="true"
            >
                {{ option.label }}
            </mat-option>
        </main>
    </mat-select>
</mat-form-field>
